<template>
    <wysiwyg
        v-bind="$attrs"
        :html="value"
        :options="options"
        @change="$emit('input', $event)"
    />
</template>

<script>

    export default {
        name: "TextEditor",
        props: {
            value: {
                type: String,
                default: null
            }
        },
        computed: {
            options() {
                return {
                    image: {
                        uploadURL: "/api/uploads",
                        dropzoneOptions: {
                            headers: {
                                Authorization: 'Bearer ' + this.$auth.token()
                            }
                        }
                    },
                    maxHeight: "500px",
                    forcePlainTextOnPaste: true
                }
            }
        }
    }
</script>
